export const PRACT_LOGGED_IN = "PRACT_LOGGED_IN";
export const PRACT_LOGGED_OUT = "PRACT_LOGGED_OUT";
export const USER_EXISTS_MYSQL = "USER_EXISTS_MYSQL";
export const USER_EXISTS_4D = "USER_EXISTS_4D";
export const GET_PATIENTS = "GET_PATIENTS";
export const GET_LAST_TEN_RESULTS = "GET_LAST_TEN_RESULTS";
export const CLEAR_LAST_RESULST = "CLEAR_LAST_RESULST";
export const ALL_PATIENT_ORDERS = "ALL_PATIENT_ORDERS";
export const PATIENT_ORDER_RESULTS = "PATIENT_ORDER_RESULTS";
export const PATIENT_ORDER_RESULTS_ONE = "PATIENT_ORDER_RESULTS_ONE";
export const PATIENT_HISTORIC = "PATIENT_HISTORIC";
export const ADD_TO_LIST = "ADD_TO_LIST";
export const REMOVE_FROM_LIST = "REMOVE_FROM_LIST";
export const RESET_LIST = "RESET_LIST";
export const REMOVE_ALL = "REMOVE_ALL";
export const CLEAR_ALL_PATIENT_ORDERS = "CLEAR_ALL_PATIENT_ORDERS";
export const CLEAR_PATIENT_ORDER_RESULTS = "CLEAR_PATIENT_ORDER_RESULTS";
//export const CLEAR_PATIENT_ORDER_RESULTS_ONE= "CLEAR_PATIENT_ORDER_RESULTS_ONE";
export const CLEAR_PATIENT_HISTORIC = "CLEAR_PATIENT_HISTORIC";
export const SHOW_EDIT_FORM = "SHOW_EDIT_FORM";
export const PRACTITIONER_INFO = "PRACTITIONER_INFO";
export const ENTITY_INFO = "ENTITY_INFO";
export const SELECTED_ENTITY = "SELECTED_ENTITY";

export const SELECTED_PATIENT = "SELECTED_PATIENT";
export const CLEAR_SELECTED_PATIENT = "CLEAR_SELECTED_PATIENT";
export const ALL_PRACTITIONERS = "ALL_PRACTITIONERS";
export const ALL_ENTITIES = "ALL_ENTITIES";
export const CLEAR_SELECTED_ENTITY = "CLEAR_SELECTED_ENTITY";
export const SELECTED_PRACTITIONER = "SELECTED_PRACTITIONER";
export const CLEAR_SELECTED_PRACTITIONER = "CLEAR_SELECTED_PRACTITIONER";
export const CLEAR_ENTITY_INFO = "CLEAR_ENTITY_INFO";
export const CLEAR_PRACTITIONER_INFO = "CLEAR_PRACTITIONER_INFO";
export const DELETE_SELECTED_PRACTITIONER = "DELETE_SELECTED_PRACTITIONER";

export const FETCH_CITIES_BEGIN = "FETCH_CITIES_BEGIN";
export const FETCH_CITIES_SUCCESS = "FETCH_CITIES_SUCCESS";
export const FETCH_CITIES_FAILURE = "FETCH_CITIES_FAILURE";

export const FETCH_ENTITY_RELATIONS_BEGIN = "FETCH_ENTITY_RELATIONS_BEGIN";
export const FETCH_ENTITY_RELATIONS_SUCCESS = "FETCH_ENTITY_RELATIONS_SUCCESS";
export const FETCH_ENTITY_RELATIONS_FAILURE = "FETCH_ENTITY_RELATIONS_FAILURE";

export const FETCH_USER_RELATIONS_SUCCESS = "FETCH_USER_RELATIONS_SUCCESS";
export const FETCH_USER_RELATIONS_BEGIN = "FETCH_USER_RELATIONS_BEGIN";
export const FETCH_USER_RELATIONS_FAILURE = "FETCH_USER_RELATIONS_FAILURE";

export const FETCH_ENTITY_ORDERS_BEGIN = "FETCH_ENTITY_ORDERS_BEGIN";
export const FETCH_ENTITY_ORDERS_SUCCESS = "FETCH_ENTITY_ORDERS_SUCCESS";
export const FETCH_ENTITY_ORDERS_FAILURE = "FETCH_ENTITY_ORDERS_FAILURE";

export const ALL_PASSWORD_CONFIGURATIONS = "ALL_PASSWORD_CONFIGURATIONS";

export const FETCH_PATIENTS = 'FETCH_PATIENTS';

export const SET_FILTER_RANGE = 'SET_FILTER_RANGE';
